<template>
  <div class="head clearfix">
    <!-- 会员登录以及登录信息显示 -->
    <div class="head_login">
      <span>{{ userInfoLength ? userInfo.individualName : ''}}</span>
      <span >{{userInfoLength ? userInfo.searchKey : ''}}</span>
      <span v-if="userInfoLength" >{{ userInfoLength ? userInfo.exchangeableSUMPiont: ''}}分</span>
      <router-link v-if="userInfoLength" to='/record'>我的兑换记录</router-link>
      <router-link class="color_none" to="/login" v-if="!userInfoLength">登录</router-link>
      <span v-if="userInfoLength" @click="_out">
          退出
        </span>
    </div>
    <!-- 筛选搜索 -->
    <div class="head_logo clearfix">
      <div class="head_img">
        <img src="../assets/images/eeka.png" alt="">
      </div>
      <div class="head_search clearfix">
        <div class="search_right">
        <span class="range">积分范围：
          <span class="head_range">
            <select name="range" v-model="scorescope" @change="_score()">
              <option selected value="" >选择积分范围</option>
              <option value="0,2000">0-2000</option>
              <option value="2001,5000">2001-5000</option>
              <option value="5001,8000">5001-8000</option>
              <option value="8001,12000">8001-12000</option>
              <option value="12001,20000">12001-20000</option>
              <option value="20001,">20001以上</option>
            </select>
          </span>
        </span>
          <span class="gift">
            礼品名称：
          <span class="head_gift">
            <input type="text" placeholder="请填写" class="gift_input" @keyup.enter="searchList()" v-model="gift_search">
            <span><img src="../assets/images/search.png" alt=""></span>
          </span>
        </span>
        </div>
      </div>
    </div>
    <!-- 头部导航tab -->
    <div class="bar">
      <ul class="clearfix flex-box">
        <li :class="{'bartop': !selectId}"  @click="getGoodTypeList()">首页</li>
        <li :class="{'bartop': selectId === 996}"  @click="getGoodTypeList(996)">所有礼品</li>
        <li :class="{'bartop': selectId === b.id}" v-for="b in goodsTypeList"  :key="b.id" @click="getGoodTypeList(b.id)">
          {{b.name}}
          <span class="hotBox" v-if="b.hot">
            <img src="../assets/images/hot-icon.gif" alt="">
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  getAllGoodsType
} from "@/api/api";
import common from '@/libs/common';
export default{
  name: 'OmniHead',
  data() {
    return {
      userInfoLength:  0,
      userInfo: {},
      goodsTypeList: [],
      gift_search: '',
      scorescope: '',
      selectId: '',  // 当前点击选择的是哪个类别
    }
  },
  watch:{
    $route(){
        this.selectId = ~~this.$route.query.id;
    }
  },
  methods: {
    getAllGoodsType() {
      getAllGoodsType().then(res => {
        this.goodsTypeList = res.data.data;
        sessionStorage.setItem("goodsTypeList", JSON.stringify(res.data.data));
      })
    },
    _out() {
       this.$confirm('确认退出当前账户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          common.setUserInfo('');
          common.setToken('');
          window.location.reload();
        }).catch(() => {
                 
        });
    },
    getGoodTypeList(id) {
      this.selectId = id;
      if(id) {
        this.$router.push({
          name: "List",
          query: {id:id}
        });
      }else{
        this.$router.push({
          name: "Home",
        });
      }
    },
    searchList() {
      if(this.gift_search) {
        this.scorescope = "";
        this.$router.push({
            name: "searchList",
            query: {"qp-name-like": this.gift_search}
          });
      }
    },
    _score(){
      if(this.scorescope){
          this.gift_search = "";
          this.$router.push({
            name: "searchList",
            query: {"qp-score-ge": this.scorescope.split(',')[0],"qp-score-le": this.scorescope.split(',')[1]}
          });
      }
    }
  },
  mounted() {
    if(JSON.stringify(common.getUserInfo()) !== 'null' && Object.keys(common.getUserInfo()).length > 0) {
      this.userInfoLength = Object.keys(common.getUserInfo()).length;
      this.userInfo = common.getUserInfo();
    }
    this.getAllGoodsType();
  }
}
</script>

<style lang="css" scoped>
.color_none{ color:#333;line-height: 15px }
  .head{width:100%;margin: 0 auto;background: #f9f9fb;}
  .head_logo{width: 1000px;margin: 0 auto 20px auto;}
  .head_img{width: 220px;float: left}
  .head_img img{width: 100%;height: 100%}
  .head_login{width: 1000px;margin: 0 auto;  height: 50px;  line-height: 50px;text-align: right;}
  .head_login input{overflow: visible;  border-radius: 5px;padding-left: 10px; width: 150px;height: 20px;line-height: 20px;border: 1px solid #000000;}
  .head_login span{cursor: pointer}
  .head_login span:not(:last-child){width: 150px;height: 20px;box-sizing: border-box;margin-right: 20px;}
  .head_search{width: 60%;float: right}
  .search_right{float: right;height: 50px;line-height: 50px;width: 800px;text-align: right;}
  .head_img h1{font-family: serif;}
  .range{display: inline-block;color: #5e5e5e;margin-right: 20px;}
  .gift{display: inline-block;line-height: 25px;color:#5e5e5e}
  .head_range select{border: none;color: #5e5e5e}
  .head_range{ border: 1px solid #5e5e5e;  display: inline-block;  height: 25px;  line-height: 25px;padding: 0 10px;}
  .head_gift{display: inline-block;  height: 25px;  line-height: 25px;border: 1px solid #5e5e5e;width: 130px;}
  .head_gift span{cursor: pointer}
  .gift_select{border-right: 1px solid #000000;padding: 0 15px;}
  .gift_input{border: none;width: 100px}
  .goods_input{border-right: 1px solid #000000;border-top: none;border-bottom: none;border-left:none;width: 150px;}
  .bar{border-top: 1px solid #5e5e5e;}
  .bar ul{width: 1100px;  height: 50px;line-height: 50px;margin: 0 auto}
  .bartop{border-top: 4px solid #000000}
  .bar ul li{position: relative;display:inline-block;font-size: 16px; color: #000000;text-align: center;height: 40px;line-height: 40px;cursor: pointer;width: 90px;}
  .bar ul li:hover{opacity: 0.6}
  .bar li:not(:last-child){}
  .bar li:not(:first-child){}
  .bar li:first-child{}
  .bar_right{width: 50px;height: 50px;background-color:rgb(109, 26, 34);float: right;display: flex;  flex-direction: column;  justify-content: center;  align-items: center;}
  .bar_right img{width: 80%;}
  .flex-box{display: flex;}
  .flex-box li{flex: 1;}
  .hotBox{position: absolute;right: 0;top: -8px;}
  .hotBox img{width: 27px;height: 19px;}
</style>
